var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"overview-system__overview-units"},_vm._l((_vm.toolUnits),function(toolUnit,index){return _c('OverviewSystemUnit',{key:((toolUnit.guid) + "_" + index),attrs:{"tool-unit":toolUnit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }